import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b12b2c08"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-plus me-2" }, null, -1))
const _hoisted_2 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_3 = {
  ref: "datatable",
  class: "table table-striped table-hover"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ชื่อผู้ใช้"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ชื่อ-นามสกุล"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "อีเมล"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "สิทธิ์การใช้งาน"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "สถานะ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog" })
    ])
  ])
], -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user me-2" }, null, -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-times me-2" }, null, -1))
const _hoisted_11 = { class: "badge bg-primary rounded-pill me-1" }
const _hoisted_12 = { class: "badge bg-success rounded-pill me-1" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-sync" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_UserFormComponent = _resolveComponent("UserFormComponent")!
  const _component_UserResetPasswordFormComponent = _resolveComponent("UserResetPasswordFormComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn btn-primary mb-3",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createClick && _ctx.createClick(...args)))
    }, [
      _hoisted_1,
      _createTextVNode("เพิ่มผู้ใช้งานระบบ ")
    ]),
    _createElementVNode("div", null, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: "row-hover",
                    onClick: ($event: any) => (_ctx.editClick(user.id))
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    (user.isActive)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                          _hoisted_7,
                          _createTextVNode(_toDisplayString(user.userName), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_8, [
                          _createElementVNode("button", {
                            class: "cell-item text-danger",
                            onClick: _withModifiers(($event: any) => (_ctx.deleteUserClick(user.id)), ["stop"])
                          }, [
                            _hoisted_10,
                            _createTextVNode("ลบผู้ใช้งาน ")
                          ], 8, _hoisted_9)
                        ])),
                    _createElementVNode("td", null, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1),
                    _createElementVNode("td", null, _toDisplayString(user.email), 1),
                    _createElementVNode("td", null, [
                      (user.roles.length <= 2)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(user.roles, (role, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "badge bg-primary rounded-pill me-1",
                              key: index
                            }, _toDisplayString(role.name), 1))
                          }), 128))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(user.roles[0].name), 1),
                            _createElementVNode("span", _hoisted_12, " และอีก " + _toDisplayString(user.roles.length - 1) + " สิทธิ์ ", 1)
                          ], 64))
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["far", {
                  'fa-times-circle text-danger': !user.isActive,
                  'fa-check-circle text-success': user.isActive
                }])
                      }, null, 2)
                    ]),
                    _createElementVNode("td", null, [
                      (user.passwordChanged && user.isActive)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "cell-item text-danger",
                            title: "รีเซ็ตรหัสผ่านเป็นค่าเริ่มต้น",
                            onClick: _withModifiers(($event: any) => (_ctx.resetPasswordClick(user.id)), ["stop"])
                          }, _hoisted_16, 8, _hoisted_14))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_5))
                }), 128))
              ])
            ], 512)
          ]))
    ]),
    _createVNode(_component_UserFormComponent, {
      ref: "userForm",
      "user-id": _ctx.userId
    }, null, 8, ["user-id"]),
    _createVNode(_component_UserResetPasswordFormComponent, {
      ref: "userResetPasswordForm",
      "user-id": _ctx.userId
    }, null, 8, ["user-id"])
  ], 64))
}